import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-610c51c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "portfolioVesting"
}
const _hoisted_2 = { class: "portfolioVesting__header" }
const _hoisted_3 = {
  key: 0,
  class: "portfolioVesting__list"
}
const _hoisted_4 = { class: "portfolioVesting__line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-hidden" }, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "start-date" }
const _hoisted_7 = { class: "end-date" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.accountType === 5 || $setup.accountType === 2)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.DETAILS")), 1 /* TEXT */),
        ($setup.userStore.getAccountVestingDetails && $setup.filterVestingArray($setup.userStore.getAccountVestingDetails).length
         ||
         $setup.contVestingDetails && $setup.filterVestingArray($setup.contVestingDetails).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.START_DATE")), 1 /* TEXT */),
                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.END_DATE")), 1 /* TEXT */),
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.LOCKED")), 1 /* TEXT */),
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.TIME")), 1 /* TEXT */)
              ]),
              _createCommentVNode(" Periodic vesting "),
              ($setup.accountType === 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterVestingArray($setup.userStore.getAccountVestingDetails), (item, index) => {
                      return (_openBlock(), _createBlock($setup["PortfolioVestingLine"], {
                        vesting: item,
                        key: index
                      }, null, 8 /* PROPS */, ["vesting"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : ($setup.accountType === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" Continuous vesting "),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterVestingArray($setup.contVestingDetails), (item, index) => {
                          return (_openBlock(), _createBlock($setup["PortfolioVestingLine"], {
                            vesting: item,
                            key: index
                          }, null, 8 /* PROPS */, ["vesting"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.NO_ACTIVE")), 1 /* TEXT */))
      ]))
    : _createCommentVNode("v-if", true)
}